export const CALENDAR_EVENT = 'Calendar Button Clicked';

export const TAB_TO_SECTION = {
  oneWay: 'single',
  round: 'rounded',
  openTicket: 'open',
};

export const CALENDAR_CONTINUE_EVENT = 'Calendar Continue Clicked';
